/**
 * Extracts the id's from the array of data items
 *
 * @param {JsonApi.ResourceObject[]} data
 * @returns
 */
export function extractResourceIds(data: any[]): string[] {
  return data.map(({ id }) => id)
}
